import { updateUser } from "@/store/reducers/userSlice";
import userSelector from "@/store/selectors/userSelector";
import { useQuery } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";

interface IHasPermissionWrapperProps {
  permission?: string;
  role?: 'READ_ONLY' | 'INVOICE_EDITOR' | 'POWER_USER';
  primaryOnly?: boolean;
  children: React.ReactNode;
}

const HasPermissionWrapper = ({children, permission, role, primaryOnly}: IHasPermissionWrapperProps) => {
  const dispatch = useDispatch();
  const currentUser = useSelector(userSelector);

  const {data: user} = useQuery({
    queryKey: ['me', currentUser?.session_id],
    queryFn: async () => {
      const res = await dispatch(updateUser()).unwrap();
      return res;
    },
    enabled: !!currentUser?.session_id
  });
  if (!user) return null;
  if (permission && !user.privileges?.includes(permission)) return null;
  // Role checks are temporarily disabled; keep prop for backward compatibility.
  void role;
  if (primaryOnly && !user.primaryUser) return null;
  return children;
};

export default HasPermissionWrapper;
